import React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/utils/cn';
import type { PageHeaderProps, BreadcrumbItem } from '@/types/layout.types';

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  breadcrumbs,
  actions,
  className,
}) => {
  return (
    <div className={cn('mb-8', className)}>
      {/* Breadcrumbs */}
      {breadcrumbs && breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="mb-4">
          <ol className="flex items-center gap-2 text-sm text-gray-500">
            <li>
              <a href="/dashboard" className="hover:text-gray-700 transition-colors">
                Home
              </a>
            </li>
            {breadcrumbs.map((crumb, index) => (
              <li key={index} className="flex items-center gap-2">
                <ChevronRight className="h-4 w-4 text-gray-400" />
                {crumb.href && !crumb.isActive ? (
                  <a href={crumb.href} className="hover:text-gray-700 transition-colors">
                    {crumb.label}
                  </a>
                ) : (
                  <span className={cn(crumb.isActive && 'text-gray-900 font-medium')}>
                    {crumb.label}
                  </span>
                )}
              </li>
            ))}
          </ol>
        </nav>
      )}

      {/* Title and Actions */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          {subtitle && <p className="text-gray-600 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex items-center gap-3">{actions}</div>}
      </div>
    </div>
  );
};

export default PageHeader;